import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import classes from '../../non-vector-image-upload-popup.scss';
export const ButtonGroup = ({
  isLimitedEdition,
  handleClickContinueUpload,
  handleClickUploadNewFile
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    className: classes.greyButton,
    type: ButtonType.fullGrey,
    size: ButtonSize.large,
    onClick: handleClickContinueUpload
  }, "Continue with Current File"), /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    className: classnames(classes.button, {
      [classes.orangeButton]: isLimitedEdition
    }),
    type: ButtonType.primary,
    size: ButtonSize.large
  }, /*#__PURE__*/React.createElement("input", {
    className: classes.fileInputButton,
    onChange: handleClickUploadNewFile,
    type: "file"
  }), "Upload a Vector File"));
};